import styled from 'styled-components';
import { Link as RRDLink, LinkProps } from 'react-router-dom';

export const Link = styled(RRDLink)<LinkProps>`
  text-decoration: none;
  color: inherit;
`;
